import { Alert, AlertTitle, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { GlobalContext } from 'GlobalContext';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { assingOrgpath, gettingAreas, gettingHiring, gettingSubcompanies, gettingWorkPositions } from 'utils/Employees';
import type { AreaBase, SubcompanyBase, WorkPositionBase, AreaProps, AssingProps } from 'components/dialog/employee/types';

const Area = ({ itemId, area, setSelectedOrgpath }: AreaProps) => {
    const handleAreaClick = (data: string[]) => {
        setSelectedOrgpath(data);
    };
    return (
        <>
            {area.subareas.length === 0 ? (
                <TreeItem
                    itemId={`${itemId}/${area.area_id}`}
                    label={area.area_name}
                    disabled={area.work_positions.length === 0}
                    // onClick={() => handleAreaClick([])}
                >
                    {area.work_positions.map((work_position) => (
                        <TreeItem
                            key={work_position.work_position_id}
                            itemId={`${itemId}/${area.area_id}/${work_position.work_position_id}`}
                            label={work_position.work_position_name}
                            onClick={() => {
                                handleAreaClick(`${itemId}/${area.area_id}/${work_position.work_position_id}`.split('/').filter((elemento) => elemento !== ''));
                                console.log('2');
                            }}
                        />
                    ))}
                </TreeItem>
            ) : (
                <TreeItem
                    itemId={`${itemId}/${area.area_id}`}
                    label={area.area_name}
                    // onClick={() => handleAreaClick([])}
                >
                    {area.subareas.map((subarea) => (
                        <Area key={subarea.area_id} itemId={`${itemId}/${area.area_id}`} area={subarea} setSelectedOrgpath={handleAreaClick} />
                    ))}
                </TreeItem>
            )}
        </>
    );
};

const AssingPosition = ({ open, setOpen, reloading, data }: AssingProps) => {
    const { t } = useTranslation();

    const { handlerAlert } = useContext(GlobalContext);

    const [contracts, setContracts] = useState<HiringRange[]>([]);
    const [selectedContract, setSelectedContract] = useState<number | null>(null);

    const [subcompanies, setSubCompanies] = useState<SubcompanyBase[]>([]);
    const [selectedSubcompany, setSelectedSubcompany] = useState<number | null>(null);

    const [areas, setAreas] = useState<AreaBase[]>([]);
    //const [selectedArea, setSelectedArea] = useState("");

    const [, setWorkPositions] = useState<WorkPositionBase[]>([]);
    //const [selectedWorkPosition, setSelectedWorkPosition] = useState("");

    const [loadingContracts, setLoadingContracts] = useState(false);
    const [loadingSubCompanies, setLoadingSubCompanies] = useState(false);
    const [, setLoadingAreas] = useState(false);
    const [, setLoadingWorkPositions] = useState(false);
    const [loadingAssingPosition, setLoadingAssingPosition] = useState(false);
    const [alerts, setAlerts] = useState(false);

    const [selectedOrgpath, setSelectedOrgpath] = useState<string[]>([]);

    const hasUnsavedChanges = () => {
        return selectedContract !== null || selectedSubcompany !== null || selectedOrgpath.length > 0;
    };

    const closing = (skipConfirm = false) => {
        if (!skipConfirm && hasUnsavedChanges()) {
            setAlerts(true);
            return;
        }

        setOpen(false);
        setSelectedContract(null);
        setSelectedSubcompany(null);
        setSelectedOrgpath([]);
        setLoadingContracts(false);
        setLoadingSubCompanies(false);
        setLoadingAreas(false);
        setLoadingWorkPositions(false);
        setLoadingAssingPosition(false);
        setAlerts(false);
    };

    useEffect(() => {
        if (open) {
            gettingHiring(setLoadingContracts, { employee_id: data.employee_id }, setContracts);

            gettingSubcompanies(setLoadingSubCompanies, setSubCompanies);

            gettingAreas(setLoadingAreas, {}, setAreas);

            gettingWorkPositions(setLoadingWorkPositions, {}, setWorkPositions);
            console.log('data', data);
        }
    }, [data, open]);

    useEffect(() => {
        console.log('selectedOrgpath:', selectedOrgpath, 'selectedContract:', selectedContract, 'selectedSubcompany:', selectedSubcompany);
    }, [selectedContract, selectedOrgpath, selectedSubcompany]);

    return (
        <>
            <Dialog open={open} onClose={() => closing(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ background: (theme) => theme.palette.background.default }}>
                    <Typography variant="body2">{t('timekeeper.employees.dialog.assign_position.title')}</Typography>
                </DialogTitle>

                {alerts && (
                    <Box sx={{ top: 0, zIndex: 10, pb: 1, px: 3, pt: 2 }}>
                        <Alert
                            variant="filled"
                            severity="warning"
                            action={
                                <>
                                    <Button onClick={() => setAlerts(false)} color="primary" size="small" variant="text" disableElevation>
                                        {t('general.alerts.unsaved_changes.buttons.yes')}
                                    </Button>
                                    <Button onClick={() => closing(true)} color="error" size="small" variant="text" disableElevation>
                                        {t('general.alerts.unsaved_changes.buttons.no')}
                                    </Button>
                                </>
                            }
                        >
                            <AlertTitle>{t('general.alerts.unsaved_changes.message')}</AlertTitle>
                        </Alert>
                    </Box>
                )}

                <DialogContent dividers sx={{ background: (theme) => theme.palette.background.default }}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                            <FormControl fullWidth sx={{ mt: 1.5 }} disabled={loadingContracts}>
                                <InputLabel id="hiring-select-label">{t('timekeeper.employees.dialog.assign_position.contract')}</InputLabel>
                                <Select
                                    labelId="hiring-select-label"
                                    required
                                    id="hiring-select"
                                    value={selectedContract}
                                    label={t('timekeeper.employees.dialog.assign_position.contract')}
                                    onChange={(e) => {
                                        //@ts-ignore
                                        setSelectedContract(e.target.value);
                                    }}
                                >
                                    {contracts.map((hiring_rang) => (
                                        <MenuItem value={hiring_rang?.hiring?.hiring_id} key={'hiring-select-' + hiring_rang.hiring_range_id}>
                                            {`${hiring_rang?.hiring?.name_hiring} | ${new Date(hiring_rang.start_date).toLocaleDateString()}-${new Date(hiring_rang.end_date).toLocaleDateString()}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid size={12}>
                            <FormControl fullWidth sx={{ mt: 1.5 }} disabled={loadingSubCompanies}>
                                <InputLabel id="subcompany-select-label">{t('timekeeper.employees.dialog.assign_position.subcompany')}</InputLabel>
                                <Select
                                    labelId="subcompany-select-label"
                                    required
                                    id="subcompany-select"
                                    label={t('timekeeper.employees.dialog.assign_position.subcompany')}
                                    value={selectedSubcompany}
                                    onChange={(p) => {
                                        setSelectedSubcompany(Number(p.target.value));
                                    }}
                                >
                                    {subcompanies.map((sc) => (
                                        <MenuItem value={sc.subcompany_id} key={'subcompany-select-' + sc.subcompany_name}>
                                            {sc.subcompany_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid size={12}>
                            {t('timekeeper.employees.dialog.assign_position.area')}

                            <Box sx={{ minWidth: '100%' }}>
                                <SimpleTreeView>
                                    {areas
                                        .filter((area) => area.subcompany_id === selectedSubcompany && area.area_level === 1)
                                        .map((a) => (
                                            <Area key={a.area_id} area={a} itemId={''} setSelectedOrgpath={setSelectedOrgpath} />
                                        ))}
                                </SimpleTreeView>
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions
                    sx={{
                        background: (theme) => theme.palette.background.default,
                    }}
                >
                    <Button variant="outlined" color="error" onClick={() => closing(false)}>
                        {t('timekeeper.employees.dialog.assign_position.buttons.cancel')}
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            assingOrgpath(
                                setLoadingAssingPosition,
                                {
                                    employee_id: data.employee_id,
                                    subcompany: selectedSubcompany,
                                    areas: selectedOrgpath.slice(0, -1).map((elemento) => parseInt(elemento)),
                                    puesto: parseInt(selectedOrgpath[selectedOrgpath.length - 1]),
                                    hiring_id: selectedContract,
                                },
                                closing,
                                reloading,
                                handlerAlert,
                                t,
                            );
                        }}
                        disabled={selectedOrgpath.length === 0 || selectedContract === null || selectedSubcompany === null}
                        loading={loadingAssingPosition}
                    >
                        {t('timekeeper.employees.dialog.assign_position.buttons.assign')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export { AssingPosition };
